import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import './ArticleImage.scss';

export const ArticleImage = ({ inputs }) => {
    if (!inputs.verticalImage && !inputs.horizontalImage) return null;

    if (inputs.isVertical && inputs.verticalImage) {
        return (
            <figure className="article-image">
                <div className="vertical-wrapper">
                    <GatsbyImage
                        image={getImage(inputs.verticalImage)}
                        alt={inputs?.alt ?? ``}
                        className="vertical"
                    />
                    {inputs.caption && (
                        <figcaption className="caption">
                            {inputs.caption}
                        </figcaption>
                    )}
                </div>
            </figure>
        );
    } else if (inputs.horizontalImage) {
        return (
            <figure className="article-image">
                <GatsbyImage
                    image={getImage(inputs.horizontalImage)}
                    alt={inputs?.alt ?? ``}
                    className=" horizontal"
                />
                {inputs.caption && <figcaption>{inputs.caption}</figcaption>}
            </figure>
        );
    }
};
